/**
 * @file   src\components\Tutorial\DocumentationTutorial.js
 * @brief  This file is responsible for Documentation for tutorial in web view
 * @date   May, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { Button } from "react-bootstrap";
const DocumentationTutorial = (props) => {
  const { index, step, continuous, primaryProps, skipProps, size, isLastStep } =
    props;
  let finalStepBtn = props.finalStepBtn ? props.finalStepBtn : "Got It !";
  let hideBtns = props.hideBtns ? props.hideBtns : false;
  let hideCounter = props.hideCounter ? props.hideCounter : false;
  return (
    <>
      <div className="joyride-left-introsec">
        {!hideCounter && (
          <div className="joyride-left-count">
            {parseInt(index) + 1} of {size}
          </div>
        )}
        <div className="joyride-step-title">
          {step.title}{" "}
          {step.icon && (
            <span className="joyride-step-icon">
              <img src={step.icon} alt={step.icon}/>
            </span>
          )}
        </div>

        <div className="joyride-step-para">{step.content}</div>

        {continuous && !hideBtns && (
          <Button variant="" className="btn-primary" {...primaryProps}>
            {isLastStep ? finalStepBtn : "Next"}
          </Button>
        )}
        {step.showSkipButton && !hideBtns && (
          <Button variant="" className="btn-secondary float-end" {...skipProps}>
            Skip All
          </Button>
        )}
      </div>
    </>
  );
};
export default DocumentationTutorial;
